// English strings for reception lookup by vehicle plate and permitted ID number (PB-06-02,
// PD-492 – PD-495). Arabic: ar-reception-lookup.ts.
export const enReceptionLookup = {
  'rlk.v.plate': 'Enter a plate number using letters and digits only.',
  'rlk.v.number': 'This is not a valid number for the chosen document type.',
  'rlk.field': 'Search by',
  'rlk.field.any': 'Name, reference, card or pass link',
  'rlk.field.plate': 'Vehicle plate',
  'rlk.field.document': 'ID document number',
  'rlk.hint.plate': 'Type the plate as written, for example D 12345. Similar characters (O and 0, I and 1) also match.',
  'rlk.hint.document': 'Type the number from the visitor’s ID. It is checked without being stored, and only the last four characters are shown.',
  'rlk.documentType': 'Document type',
  'rlk.documentType.any': 'Any enabled type',
  'rlk.documentJurisdiction': 'Issuing country (for passports)',
  'rlk.match.plate': 'Plate {masked}',
  'rlk.match.plateNear': 'Plate {masked} — similar characters, check the plate',
  'rlk.match.document': 'ID number {masked}',
} as const;
